import React from 'react';

import { GetStaticProps } from 'next';

import { getHeaderFooterStaticProps, HeaderFooterStaticProps } from 'cms';

import Layout from '../../components/landing-pages-v2/Layout';
import BuilderSalesPage from '../../components/partners/BuilderSalesPage';
import ReduxWrapper from '../../components/shared/ReduxWrapper';

const Page: React.FC<HeaderFooterStaticProps> = ({ header, footer }) => {
  return (
    <ReduxWrapper>
      <Layout header={header ?? undefined} footer={footer ?? undefined} slug="/partners/builders">
        <BuilderSalesPage />
      </Layout>
    </ReduxWrapper>
  );
};

export const getStaticProps: GetStaticProps<HeaderFooterStaticProps> = getHeaderFooterStaticProps;

export default Page;
